import Phaser from 'phaser';
import { mountLobby } from '../ui/lobby.js';

export class LobbyScene extends Phaser.Scene {
  constructor() {
    super('LobbyScene');
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#0c1b12');
    void mountLobby(() => {
      this.scene.start('GameScene');
    });
  }
}
